module.exports = __webpack_public_path__ + "img/ic-minus.805c3831.svg";